import React from "react";
import { Box, Container, Grid, Skeleton } from "@mui/material";

const BlogSkeleton = () => {
  return (
    <>
      {/* Skeleton for Page Header */}
      <Box
        sx={{
          backgroundImage: "linear-gradient(to right, #0B0F19, #1A2E55)",
          color: "#FFFFFF",
          paddingY: "60px",
          textAlign: "center",
        }}
      >
        <Container maxWidth="lg">
          <Skeleton
            variant="text"
            width={300}
            height={40}
            sx={{
              margin: "0 auto",
              backgroundColor: "rgba(255, 255, 255, 0.3)",
            }}
          />
          <Skeleton
            variant="text"
            width={500}
            height={24}
            sx={{
              margin: "16px auto",
              backgroundColor: "rgba(255, 255, 255, 0.3)",
            }}
          />
        </Container>
      </Box>

      {/* Skeleton for Blog Cards */}
      <Box
        sx={{
          backgroundImage: "linear-gradient(to right, #0B0F19, #1A2E55)",
          color: "#FFFFFF",
          minHeight: "100vh",
          paddingY: "60px",
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            {[1, 2, 3, 4, 5, 6].map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item}>
                <Box sx={{ position: "relative" }}>
                  <Skeleton
                    variant="rectangular"
                    height={220}
                    sx={{
                      borderRadius: "12px 12px 0 0",
                      backgroundColor: "rgba(255, 255, 255, 0.2)",
                    }}
                  />
                  <Box sx={{ padding: "20px" }}>
                    <Skeleton
                      variant="text"
                      height={20}
                      width="60%"
                      sx={{
                        marginBottom: "8px",
                        backgroundColor: "rgba(255, 255, 255, 0.3)",
                      }}
                    />
                    <Skeleton
                      variant="text"
                      height={30}
                      sx={{
                        marginBottom: "12px",
                        backgroundColor: "rgba(255, 255, 255, 0.3)",
                      }}
                    />
                    <Skeleton
                      variant="text"
                      height={20}
                      width="100%"
                      sx={{
                        marginBottom: "16px",
                        backgroundColor: "rgba(255, 255, 255, 0.3)",
                      }}
                    />
                    <Skeleton
                      variant="rectangular"
                      height={36}
                      width={100}
                      sx={{
                        borderRadius: "8px",
                        backgroundColor: "rgba(255, 255, 255, 0.3)",
                      }}
                    />
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default BlogSkeleton;
